import { createContext } from 'react';
import { mensajesDe, type Mensajes } from '@/i18n/locales';
import { IDIOMA_POR_OMISION, idiomaPorOmision } from '@/i18n/idiomas';

export interface I18nContextValue {
  /** Código del idioma activo. Es lo que va en `<html lang>`. */
  idioma: string;
  /** Diccionario completo del idioma activo. Se navega por propiedades. */
  t: Mensajes;
  /** Etiqueta para `Intl` ('es-MX', 'en-US'). Ver `i18n/formato.ts`. */
  locale: string;
  cambiarIdioma: (codigo: string) => void;
}

/**
 * A diferencia de `AuthContext`, este contexto trae un valor por omisión real
 * en vez de `null`, y `useI18n` no lanza cuando no hay proveedor. Es deliberado:
 *
 *  - sin sesión no hay respuesta correcta, pero sin proveedor sí la hay:
 *    español, que es la lengua del negocio;
 *  - permite traducir pantalla por pantalla sin que las que aún no se tocan
 *    revienten;
 *  - los tests que montan páginas sueltas siguen funcionando sin envolverlas.
 */
export const I18nContext = createContext<I18nContextValue>({
  idioma: IDIOMA_POR_OMISION,
  t: mensajesDe(IDIOMA_POR_OMISION),
  locale: idiomaPorOmision().locale,
  cambiarIdioma: () => {},
});
